import styled from 'styled-components'

export const ContainerManageTeam = styled.div`
  color: #FFF;
  margin-top: 6em;
  padding: 0 55px;
`
